export default __webpack_public_path__ + "static/media/emoji-sad.1ba85643.svg";